import './datepicker-addon';

// DOMContentLoadedイベントで初期化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDatepicker);
} else {
    // 既にDOMが読み込まれている場合は即座に実行
    initDatepicker();
}

function initDatepicker() {
    // jQueryが利用可能か確認
    if (typeof jQuery === 'undefined') {
        return;
    }

    // jQuery UIのdatepickerが利用可能になるまで待機
    const checkDatapickerReady = function() {
        if (typeof jQuery.fn.datepicker === 'undefined') {
            // datepickerがまだ利用できない場合は少し待ってから再試行
            setTimeout(checkDatapickerReady, 50);
            return;
        }

        // showCalendarプラグインを初期化
        if (typeof window.initShowCalendar === 'function') {
            window.initShowCalendar();
        }

        initDatepickerCore();
    };

    checkDatapickerReady();
}

function initDatepickerCore() {
    (function($) {
        // 読み込み時に時間リストを生成
        const timeSelects = $('.js-set-timelist').find('select.time');

        timeSelects.each(function(i, time) {
            const datetime = $(time).parents('.datetime');
            const month = datetime.find('select.month').val();
            const day = datetime.find('select.day').val();
            // 月と日が選択されている場合はその日付を使用、されていない場合は現在の日付を使用
            if (month && day) {
                fillTime($(time), { month: month, day: day });
            } else {
                const now = new Date();
                fillTime($(time), { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() });
            }
        });

        // フォームに既に時間の値が設定されている場合の処理
        const fromTimeSelect = $('select[name="from_hm"]');
        const toTimeSelect = $('select[name="to_hm"]');

        // 既に時間が設定されている場合は、営業時間を取得してオプションを追加
        if (fromTimeSelect.find('option').length === 1 && fromTimeSelect.val()) {
            const fromMonth = $('select[name="from_month"]').val();
            const fromDay = $('select[name="from_day"]').val();
            fillTimeOptions(fromTimeSelect, { month: fromMonth, day: fromDay });
        }

        if (toTimeSelect.find('option').length === 1 && toTimeSelect.val()) {
            const toMonth = $('select[name="to_month"]').val();
            const toDay = $('select[name="to_day"]').val();
            fillTimeOptions(toTimeSelect, { month: toMonth, day: toDay });
        }

        // プルダウン日付変更時に時間リストを更新（委譲イベント）
        $(document).off('change', '.js-reserve-datetime select.month, .js-reserve-datetime select.day')
                   .on('change', '.js-reserve-datetime select.month, .js-reserve-datetime select.day', function(e) {
            const datetime = $(this).parents('.datetime');
            const month = datetime.find('select.month').val();
            const day   = datetime.find('select.day').val();
            fillTime(datetime.find('select.time'), { month: month, day: day });
        });

        // カレンダー表示（委譲イベント）
        $(document).off('click', '.js-show-datepicker')
                   .on('click', '.js-show-datepicker', function(e) {
            e.preventDefault();
            const datetime = $(this).parents('.datetime');
            let numberOfMonths = $(this).data('months');
            if (!parseInt(numberOfMonths, 10)) {
                numberOfMonths = 1;
            }
            const datepickerInput = $(this).parents('p').next('.datepicker');
            datepickerInput.showCalendar({
                months: 1,
                minDate: new Date(),
                numberOfMonths: numberOfMonths,
                onSelect: function(date) {
                    const d = date.split('-');
                    datetime.find('select.month').val(parseInt(d[1],10));
                    datetime.find('select.day').val(parseInt(d[2],10));
                    fillTime(datetime.find('select.time'), { date: date });
                },
            }).datepicker('show');
            // フォーカスを外してキーボード表示を防ぐ
            datepickerInput.blur();
        });

        function fillTime(selector, data) {
            // 現在選択されている値を保存
            const currentValue = selector.val();

            $.ajax({
                type: 'get',
                url: '/api/service_time',
                dataType: 'json',
                data: data,
                async: false,
                success: function(data, statusText, jqXHR) {
                    selector.empty();
                    $.each(data['hours'], function(i, hours) {
                        const option = $('<option>').text(hours).val(hours);
                        // 現在の値と一致する場合はselectedを設定
                        if (hours === currentValue) {
                            option.prop('selected', true);
                        }
                        option.appendTo(selector);
                    });
                }
            });
        }

        function fillTimeOptions(selector, data) {
            const currentValue = selector.val();

            $.ajax({
                type: 'get',
                url: '/api/service_time',
                dataType: 'json',
                data: data,
                async: false,
                success: function(data, statusText, jqXHR) {
                    $.each(data['hours'], function(i, hours) {
                        const option = $('<option>').text(hours).val(hours);
                        if (hours === currentValue) {
                            option.prop('selected', true);
                        }
                        option.appendTo(selector);
                    });
                }
            });
        }
    })(jQuery);
}
